import { render, staticRenderFns } from "./Playlist.vue?vue&type=template&id=212ef47a&"
import script from "./Playlist.vue?vue&type=script&lang=js&"
export * from "./Playlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QHeader,QToolbar,QBtn,QToolbarTitle,QDialog,QCard,QCardSection,QInput,QCardActions,QList,QItem,QItemSection,QItemLabel,ClosePopup,Ripple} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QHeader,QToolbar,QBtn,QToolbarTitle,QDialog,QCard,QCardSection,QInput,QCardActions,QList,QItem,QItemSection,QItemLabel})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup,Ripple})
